export const orderStatusLabels = {
  pending: 'À confirmer',
  'on-hold': 'À confirmer',
  'sbc-confirmed': 'Confirmée',
  'sbc-preparing': 'En préparation',
  'sbc-shipped': 'Expédiée',
  'sbc-delivered': 'Livrée',
  'sbc-refused': 'Refus client',
  cancelled: 'Annulée',
};

export function orderStatusLabel(status) {
  return orderStatusLabels[status] || status || '—';
}

export function money(cents) {
  return `${(Number(cents || 0) / 100).toLocaleString('fr-MA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MAD`;
}
